import styled from 'styled-components';
const StyledSvgWrapper = styled.svg.attrs(() => {
    return {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: `0 0 24 24`,
        className: '_ndsPaymentIcon'
    };
}) `
  width: ${(props) => props.theme.SizeWidthPaymentIconMedium};
  height: ${(props) => props.theme.SizeHeightPaymentIconMedium};

  &._ndsPaymentIcon--small {
    width: ${(props) => props.theme.SizeWidthPaymentIconSmall};
    height: ${(props) => props.theme.SizeHeightPaymentIconSmall};
  }
  &._ndsPaymentIcon--medium {
    width: ${(props) => props.theme.SizeWidthPaymentIconMedium};
    height: ${(props) => props.theme.SizeHeightPaymentIconMedium};
  }
  &._ndsPaymentIcon--large {
    width: ${(props) => props.theme.SizeWidthPaymentIconLarge};
    height: ${(props) => props.theme.SizeHeightPaymentIconLarge};
  }
`;
export default StyledSvgWrapper;
//# sourceMappingURL=StyledSvgWrapper.js.map